import React, { useEffect } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import { MoreHoriz, AddCircle, RemoveCircle, DragIndicator } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { RESTAURANT_EDIT, TYPE_LIST } from '../../../../../constants/restaurantConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_RESTAURANT,
} from '../../../../../constants/RoleConsts';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import {
  PARTIAL_CHECKBOX_GREEN,
  isDragDisabled,
  updateSelectedModule,
} from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';

const InfoListTable = (props) => {
  const {
    page,
    rowsPerPage,
    onOpenDrawer,
    onViewDetails,
    selectedValue,
    handleClose,
    onClickView,
    handleCellMenuClick,
    restaurantList,
    setRestaurantList,
    setActionMenuList,
    handleChangePage,
    handleChangeRowsPerPage,
    onDeleteRestaurant,
    permissions,
    onChangeStatus,
    setVisible,
    isCulinaryOperationManager = false,
    searchText,
    isAllSelected,
    setIsAllSelected,
    selectedRestaurantsLength,
    setShowBulkSearchAlert,
    tempSearchText,
    dragDisabled,
  } = props;

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionList = [];
    let index = restaurantList?.findIndex((item) => item.id === id);
    if (!restaurantList[index]?.isChecked) {
      restaurantList[index] = { ...restaurantList[index], isChecked: true };
    } else {
      restaurantList[index].isChecked = !restaurantList[index]?.isChecked;
    }
    setRestaurantList([...restaurantList]);

    actionList = restaurantList
      ?.filter((restaurant) => restaurant?.isChecked)
      .map((status) => status?.isActive);

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }
    const isAllSelected = restaurantList?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let selectedRestaurantList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedRestaurantList = restaurantList?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedRestaurantList?.some((restaurant) => restaurant?.isActive);
    const isInactive = selectedRestaurantList?.some((restaurant) => !restaurant.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    setRestaurantList([...selectedRestaurantList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedRestaurantList.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  useEffect(() => {
    updateSelectedModule(restaurantList, setActionMenuList, setIsAllSelected);
  }, [restaurantList]);

  return (
    <>
      <TableContainer>
        <Table className='list-table' aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                <BulkActionCheckBox
                  onChange={handleSelectAll}
                  checked={isAllSelected || false}
                  selectedLength={selectedRestaurantsLength}
                  totalLength={restaurantList?.length}
                  inputProps={{
                    'aria-label': 'select all Restaurants Info',
                  }}
                  className={PARTIAL_CHECKBOX_GREEN}
                />
              </TableCell>
              <TableCell className='w-20'>Name</TableCell>
              <TableCell className='w-20'>Restaurant code</TableCell>
              <TableCell className='w-25'>Cuisine(s)</TableCell>
              <TableCell className='w-20'>Type</TableCell>
              <TableCell className='w-20' align='center'>
                Status
              </TableCell>
              <TableCell align='right'></TableCell>
            </TableRow>
          </TableHead>

          <DragDropContext
            onDragEnd={(event) =>
              handleOnDragEnd(
                event,
                setVisible,
                restaurantList,
                setRestaurantList,
                false,
                page,
                rowsPerPage,
              )
            }
            isDropDisabled={dragDisabled}
          >
            <Droppable droppableId='restaurants' isDropDisabled={dragDisabled}>
              {(provided) => (
                <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                  {(rowsPerPage > 0
                    ? restaurantList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : restaurantList
                  ).map((restaurant, key) => (
                    <Draggable
                      key={restaurant.id}
                      draggableId={restaurant.id}
                      index={key}
                      isDragDisabled={dragDisabled}
                    >
                      {(provided) => (
                        <TableRow
                          key={key}
                          className='border-white pointer'
                          onClick={(e) => {
                            onViewDetails(restaurant, e);
                          }}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <TableCell className='w-12'>
                            {!dragDisabled && (
                              <span style={{ marginRight: 1.5 }}>
                                <DragIndicator className='res-menu-accordion-drag' />
                              </span>
                            )}
                            <Checkbox
                              onChange={(event) => handleCheckboxChange(restaurant?.id)}
                              checked={restaurant?.isChecked || false}
                              inputProps={{
                                'aria-label': `select restaurant ${restaurant.id}`,
                              }}
                            />
                          </TableCell>
                          <TableCell className='w-20'>{restaurant?.name}</TableCell>
                          <TableCell className='w-20'>{restaurant?.code}</TableCell>
                          <TableCell className='w-25'>
                            {!restaurant.primaryCuisine &&
                              !restaurant?.secondaryCuisine?.length &&
                              '---'}
                            {restaurant?.primaryCuisine &&
                              (restaurant?.secondaryCuisine?.length > 0 ? (
                                <>
                                  {restaurant?.primaryCuisine?.charAt(0)?.toUpperCase() +
                                    restaurant?.primaryCuisine?.slice(1) +
                                    ', '}
                                </>
                              ) : (
                                <>
                                  {restaurant?.primaryCuisine?.charAt(0)?.toUpperCase() +
                                    restaurant?.primaryCuisine?.slice(1)}
                                </>
                              ))}
                            {restaurant?.secondaryCuisine?.length > 0 && (
                              <>
                                {restaurant?.secondaryCuisine[0].charAt(0).toUpperCase() +
                                  restaurant?.secondaryCuisine[0].slice(1)}
                              </>
                            )}
                            {restaurant?.secondaryCuisine?.length > 0 && (
                              <>
                                {restaurant?.secondaryCuisine?.length > 1 &&
                                  `, +${restaurant?.secondaryCuisine?.length - 1}`}
                              </>
                            )}
                          </TableCell>
                          <TableCell className='w-20'>
                            {TYPE_LIST.find((type) => type.value === restaurant.type)?.name}
                          </TableCell>
                          <TableCell className='w-20' align='center'>
                            <div className='d-flex justify-content-center'>
                              <div
                                className={`${
                                  restaurant.isActive ? 'pill-active ' : 'pill-inactive '
                                } pill d-flex justify-content-center align-items-center`}
                              >
                                <span className='ms-1'>
                                  {!restaurant.isActive ? 'Inactive' : 'Active'}
                                </span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell align='right'>
                            {permissions[RBAC_TYPE_HOTEL_RESTAURANT] ===
                              RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                              <Button
                                aria-controls='simple-menu'
                                aria-haspopup='true'
                                onClick={(e) => {
                                  handleCellMenuClick(e, restaurant);
                                }}
                                className='showpopupInner'
                              >
                                <MoreHoriz className='showpopupInner' />
                              </Button>
                            )}
                            <Menu
                              id={key}
                              anchorEl={selectedValue?.anchorEl}
                              disableRestoreFocus
                              MenuListProps={{ autoFocusItem: false }}
                              keepMounted
                              open={
                                Boolean(selectedValue.anchorEl) &&
                                selectedValue.id === restaurant.id
                              }
                              onClose={handleClose}
                              className='shadow'
                            >
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => {
                                  onChangeStatus(e, selectedValue.restaurant);
                                }}
                              >
                                {selectedValue.restaurant?.isActive === true ? (
                                  <>
                                    <RemoveCircle className='me-2 action-menu-icon' />
                                    Deactivate
                                  </>
                                ) : (
                                  <>
                                    <AddCircle className='me-2 action-menu-icon' />
                                    Activate
                                  </>
                                )}
                              </MenuItem>
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => {
                                  onOpenDrawer(e, RESTAURANT_EDIT);
                                }}
                              >
                                <CreateIcon className='me-2 action-menu-icon' />
                                Edit
                              </MenuItem>
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => {
                                  onClickView(e);
                                }}
                              >
                                <VisibilityIcon className='me-2 action-menu-icon' />
                                View
                              </MenuItem>
                              {!isCulinaryOperationManager && (
                                <MenuItem className='pe-4' onClick={(e) => onDeleteRestaurant(e)}>
                                  <DeleteForeverIcon className='me-2 action-menu-icon' />
                                  Delete
                                </MenuItem>
                              )}
                            </Menu>
                          </TableCell>
                        </TableRow>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </TableBody>
              )}
            </Droppable>
          </DragDropContext>

          <TableFooter>
            <TableRow className='paginator'>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                count={restaurantList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </>
  );
};

export default InfoListTable;
